import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import About from './About';

const styles = theme => ({
root: {
  flexGrow: 1,
},
header: {
  color: '#000',

},
banner: {
  paddingTop: '4em'
}

});

class Header extends Component{


  render (){
    const { classes } = this.props;
    const className = {style1: 'clip-text',
    style2: 'clip-text_one'}
    return (
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            className={classes.header}
          >
            <Grid item md={12} xs={10} className={classes.banner}>

                <div className={`${className.style1} ${className.style2}`}>Crystal Grant</div>

            </Grid>
            <Grid item md={12} xs={10} className={classes.banner}>
                <About />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(Header)
